module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/purchase/quotation-delivery-challan/qd-challan-form/qd-challan-form.component.css
// module id = ./src/app/Pages/purchase/quotation-delivery-challan/qd-challan-form/qd-challan-form.component.css
// module chunks = main